import { Component } from '@angular/core';
import { TdDialogService } from '@covalent/core';
import { MD_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY } from '@angular/material';
import { subscribeOn } from 'rxjs/operator/subscribeOn';

@Component({
  selector: 'qs-toggleconfirmar',
  templateUrl: './toggleconfirmar.component.html',
})

export class ToggleConfirmarComponent {

  constructor(private _dialogService: TdDialogService) {
  }

  openConfirm(mensaje: string, titulo: string): any {
    // let respuesta;
    this._dialogService.openConfirm({
      message: mensaje,
      disableClose: true,
      title: titulo,
      cancelButton: 'Cancelar',
      acceptButton: 'Aceptar',
      }).afterClosed().subscribe((accept: any) => {
        if (accept) {
           return true;
        } else {
          return false;
        }
      });

    /*if(respuesta)  {
     return respuesta;
    }*/
  }
  close(): void {
    this._dialogService.closeAll();
  }
  // tslint:disable-next-line: no-empty
  delete(): void {}

}



// WEBPACK FOOTER //
// ./src/app/consulta/toggleConfirmar/toggleconfirmar.component.ts